import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../store/user-slice";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { notificationActions } from "../store/notification-slice";
import Backdrop from "./Backdrop";
import useAuthorized from "../hook/useAuthorized";
import Skeleton from "react-loading-skeleton";
import { useOrder } from "../hook/useOrder";
import AppNotification from "./AppNotification";

export default function DefaultLayout() {
  let dispatch = useDispatch();

  let navigate = useNavigate();

  let notification = useSelector((state) => state.notification.notification);

  const { isAdmin, isAuthorized } = useAuthorized();

  const {getCartItems}=useOrder()

 

  useEffect(() => {
    if (isAuthorized !== null && isAdmin !== null) {
      if (!isAuthorized) {
        dispatch(userActions.setUser(null));
        navigate("/login");
      }

      if (notification) {
        setTimeout(() => {
          dispatch(notificationActions.setNotification(null));
        }, 3000);
      }

      dispatch(userActions.setIsAdmin(isAdmin));
      
      getCartItems()
    }
  }, [notification, isAdmin, isAuthorized]);



  if (isAuthorized === null || isAdmin === null ) {
    return <Skeleton count={50} />;
  }

  return (
    <div className="app-shell bg-maryam">
      <Sidebar />
      <div className="app-content">
        <Header />
        <main className="default-layout">
          <Outlet />
        </main>
      </div>

      <AppNotification notification={notification} aboveNavigation />

      <Backdrop />
    </div>
  );
}
